<template>
    <div class="loading-overlay" v-if="show">
        <font-awesome-icon icon="spinner" spin size="6x"></font-awesome-icon>
        <!-- <i class="fa fa-spinner fa-spin"></i> -->
    </div>
</template>

<script>
export default {
  name: 'LoadingOverlay',

  props: {
    show: {
      required: true,
      type: Boolean
    }
  }
}
</script>

<style lang="sass" scoped>
  .loading-overlay
    position: absolute
    background-color: rgba(0, 0, 0, .25)
    z-index: 1000
    top: 0
    left: 0
    width: 100%
    height: 100%
    display: flex
    align-items: center
    justify-content: center
    i
      width: 100px
      height: 100px
      font-size: 100px
</style>
